// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyHeader_container_MqTq9","toggler":"EmptyHeader_toggler_ZFKSd","componentContainer":"EmptyHeader_componentContainer_24Vrl"};